import EmployeeApi from "adminPanel/employee/employeeAPI";
import { ITransactions } from "adminPanel/employee/models/IEmployee";
import ApprovalsApi from "amnPos/Approvals/ApprovalsApi";
import { ISupervisor } from "amnPos/ticket/Ticket";
import useTranslate from "hooks/useTranslate";
import { useState } from "react";
import { useThemeColors } from "theme";
import { NIL } from "uuid";

export default function useSupervisorPinCode(
  OnCompletePinCode: (supervisor: ISupervisor) => void,
  HandleOnManyWrongAttempts: () => void,
  posId: string,
) {
  const [superVisorName, setSuperVisorName] = useState<string>();
  const [isError, setIsError] = useState<boolean>(false);
  const { translate } = useTranslate("pos.action");
  const colors = useThemeColors();
  function HandleOnCompletePinCode(pinCode: string) {
    EmployeeApi.GetSupervisorNameFromPinCode(pinCode, posId)
      .then((result) => {
        OnCompletePinCode(result.data);
        setSuperVisorName(result.data.supervisor);
        setIsError(false);
      })
      .catch((e) => {
        setSuperVisorName(translate("unknownSupervisor"));
        setIsError(true);
        if (isError) {
          HandleOnManyWrongAttempts();
        }
      });
  }
  return { HandleOnCompletePinCode, superVisorName, isError, colors };
}
